export const APP_NAME = 'CrediStream';
